import { ButtonHTMLAttributes, FC } from 'react'

import Icon from '../../../../components/style/Icon/Icon'

import './CalendarButtonAdd.scss'

interface CalendarButtonAddProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    className?: string;
    kind?: 'plus' | 'plus-shift-concept';
}

const CalendarButtonAdd:FC<CalendarButtonAddProps> = ({
    className = '',
    kind = 'plus',
    ...props
}) => (
    <button type="button" {...props} className={`calendar-button-add ${className}`}>
        <Icon kind={kind} className="calendar-button-add__icon" />
    </button>
)

export default CalendarButtonAdd
